import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { IOtsStaffOrderCard } from '../../core/interfaces/IOtsStaffOrderCard';

@Component({
  selector: 'ots-staff-order-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  templateUrl: './staff-order-card.component.html',
  styleUrl: './staff-order-card.component.scss',
  host: { class: 'd-block full-width c-t-blue-900' }
})
export class StaffOrderCardComponent extends BaseComponent {

  @Input() public card: IOtsStaffOrderCard | null = null;

  @Output() public advanceStatus = new EventEmitter<void>();

  protected advanceOrderStatus(): void {
    if (!this.card?.actionLabel) {
      return;
    }

    this.advanceStatus.emit();
  }
}
